import React from 'react'
import { Link } from 'gatsby'
import { buildURL, CONTENTFUL_GRAPHQL_TYPES } from './../../utils/url'
import map from 'lodash/map'

export default props => {
    const { groups, inSidebar, preview } = props
    const groupUrls = map(groups, group => {
        let isPTP = false;
        if (preview) {
            isPTP = group.isPTP;
        } else {
            isPTP = group.__typename?.includes('Ptp')
        }
        return {...group, url: buildURL(group, isPTP ? CONTENTFUL_GRAPHQL_TYPES.PAGES_GROUP_PTP : CONTENTFUL_GRAPHQL_TYPES.PAGES_GROUP)}
     })

    return inSidebar ? (
        <>
            <h5>Related</h5>
            <ul className='page-index'>
                {
                    groupUrls.map(group => <li className='item'><Link to={group.url} className="name">{group.title}</Link></li>)
                }
                
            </ul>
            
        </>
    ) :
    (
        <div className="group-widget d-flex flex-column">
            <h5>Related</h5>
            {
                groupUrls.map(group => <li className='item'><Link to={group.url} className="name">{group.title}</Link></li>)
            }
        </div>
    )
}